<div
  data-at-power-limitation-status
  class="status-container flex flex-col gap-[16px] justify-start items-start"
>
  <div class="status-title">
    {{
      powerLimitationStatus.type === ACTIVE_ERROR_TYPE.POWER_LIMITATION_CONSUMPTION
        ? ('+INSTALLATIONS.INSTALLATION.POWER_LIMITATION.CONSUMPTION_LIMIT' | translate)
        : ('+INSTALLATIONS.INSTALLATION.POWER_LIMITATION.FEED_IN_LIMITATION' | translate)
    }}
  </div>
  <div class="flex flex-col gap-[8px] justify-start items-start">
    <div class="status-description">
      {{ powerLimitationStatus?.content?.longDescription | translate }}
    </div>
    <div class="date">{{ powerLimitationStatus?.createdAt | date: 'short' }}</div>
  </div>
</div>
